// @flow
import React, { PureComponent } from 'react'
import styled, { css } from 'styled-components'
import ReactDOM from 'react-dom'
// $FlowFixMe
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { media } from 'src/theme/style-utils'

const modalRoot = document.getElementById('modal-root')
export const Align = Object.freeze({
  top: 'top'
})
type Props = {
  children?: any,
  toClose: Function,
  open: boolean,
  align?: $Values<typeof Align>,
  hideOnDesktop?: boolean
}
type State = {}

const Overlay = styled.aside`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 103;
  ${props =>
    props.align === Align.top &&
    css`
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
    `}

  ${media.desktop`
      ${props =>
        props.hideOnDesktop &&
        css`
          display: none;
        `}
      
    `}
`

class Modal extends PureComponent<Props, State> {
  el: HTMLElement

  constructor(props: Props) {
    super(props)
    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    this.el = document.createElement('div')
  }
  componentDidMount() {
    // Append the element into the DOM on mount. We'll render
    // into the modal container element (see the HTML tab).
    modalRoot && modalRoot.appendChild(this.el)
  }

  componentWillUnmount() {
    // Remove the element from the DOM when we unmount
    modalRoot && modalRoot.removeChild(this.el)
    // clear and enable scrolling
    clearAllBodyScrollLocks()
  }

  render() {
    const { children, toClose, open = false } = this.props

    if (!!open) {
      // disable body scroll when modal is open
      disableBodyScroll(this.el)
    } else {
      // Re-enable the body scroll when modal is not open
      enableBodyScroll(this.el)
    }
    // Use a portal to render the children into the element
    return ReactDOM.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      <Overlay {...this.props} onClick={toClose}>
        {children}
      </Overlay>,
      // A DOM element
      this.el
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/components/MobileHeader/Modal.js